import React from "react";
import dateFormat from "dateformat";
import cx from "classnames";
import _ from "lodash";
import { Col,  Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import NoIntegration from "src/legacy/images/integrations/nointegration.png";
import EmptyResult from "src/legacy/images/integrations/emptyresult.png";
import styles from "./styles.module.scss";
import Tooltip from "src/components/tooltip";

const DefaultAssetIcon = '/images/defaultIcons/default_asset.jpg';

class MsDynamicsOpportunityRecommendedAssetsView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      integration: this.props.integration,
      recommended: this.props.recommended,
      shared: this.props.shared,
    };
  }

  componentDidMount() {
    this.props.fetchCRMEnabledIntegration();
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.integration.item === null &&
      nextProps.integration.item !== null
    ) {
      this.props.searchMsDynamicsOpportunityRecommendedAssets(this.props.id);
      this.props.searchOpportunitySharedAssets(this.props.id);
    }

    this.setState({
      integration: nextProps.integration,
      recommended: nextProps.recommended,
      shared: nextProps.shared,
    });
  }

  _integrationNotFound() {
    return (
      !this.state.integration.loading &&
      this.state.integration.item === null &&
      !_.isEmpty(this.state.integration.errors)
    );
  }

  _renderHighlights() {
    if (
      this.state.recommended &&
      _.size(this.state.recommended,"highlights") > 0
    ) {
      return this.state.recommended.highlights;
    }

    return [];
  }

  _returnRecommendedAssets() {
    if (this.state.recommended && _.size(this.state.recommended,"highlights") > 0) {
      return this.state.recommended.assets;
    }

    return [];
  }

  _renderSharedAssets() {
    if (this.state.shared && !_.isEmpty(this.state.shared.assets)) {
      return this.state.shared.assets;
    }

    return [];
  }

  _isLoading() {
    return (
      this.state.integration.loading ||
      (this.state.recommended.searching && this.state.shared.searching)
    );
  }

  _isLoaded() {
    return (
      !this.state.integration.loading &&
      !this.state.recommended.searching &&
      !this.state.shared.searching
    );
  }

  render() {
    return (
      <div className={styles.recommendations}>
        {this._integrationNotFound() && <IntegrationNotFound />}

        {this._isLoading() && <LoadingMessage />}

        <ContentSection
          loaded={this._isLoaded()}
          highlights={this._renderHighlights()}
          recommended={this._returnRecommendedAssets()}
          recommendedSearching={this.state.recommended.searching}
          shared={this._renderSharedAssets()}
          sharedSearching={this.state.shared.searching}
        />
      </div>
    );
  }
}

class LoadingMessage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return <div className={styles.loading}>Loading...</div>
  }
}

class EmptyResultMessage extends React.Component {
  render() {
    return (
      <div className={styles.error}>
        <div className={styles.errorImageDiv}>
          <Image className={styles.errorImage} src={EmptyResult} />
        </div>
        <div className={styles.errorTitle}>No content found</div>
      </div>
    );
  }
}

class IntegrationNotFound extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className={styles.error}>
        <div className={styles.errorImageDiv}>
          <Image className={styles.errorImage} src={NoIntegration} />
        </div>
        <div className={styles.errorTitle}>
          Your integration has been deactivated in Paperflite.
        </div>
      </div>
    );
  }
}

class ContentSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      highlights: [],
      selectedHighlights: [],
      recommended: [],
      recommendedSearching: false,
      shared: [],
      sharedSearching: false,
      loaded: false,
    };

    this._toggleHighlight = this._toggleHighlight.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      loaded: nextProps.loaded,
      highlights: nextProps.highlights,
      recommended: nextProps.recommended,
      recommendedSearching: nextProps.recommendedSearching,
      shared: nextProps.shared,
      sharedSearching: nextProps.sharedSearching,
    });
  }

  _toggleHighlight(highlight) {
    let selectedHighlights = this.state.selectedHighlights;

    let index = selectedHighlights.indexOf(highlight);

    if (index === -1) {
      selectedHighlights.push(highlight);
    } else {
      selectedHighlights.splice(index, 1);
    }

    this.setState({ selectedHighlights: selectedHighlights });
  }

  render() {
    return (
      <div className={styles.contentSection}>
        {(!_.isEmpty(this.state.recommended) ||
          !_.isEmpty(this.state.shared)) && (
          <RecommendationHeader
            highlights={this.state.highlights}
            selectedHighlights={this.state.selectedHighlights}
            toggleHighlight={this._toggleHighlight}
          />
        )}

        {this.state.loaded &&
          _.isEmpty(this.state.recommended) &&
          <EmptyResultMessage />}

        {!_.isEmpty(this.state.recommended) && (
          <RecommendedAssets
            highlights={this.state.highlights}
            selectedHighlights={this.state.selectedHighlights}
            assets={this.state.recommended}
          />
        )}
      </div>
    );
  }
}

class RecommendationHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      highlights: this.props.highlights,
      selectedHighlights: this.props.selectedHighlights,
    };

    this._isHighlightTag = this._isHighlightTag.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      highlights: nextProps.highlights,
      selectedHighlights: nextProps.selectedHighlights,
    });
  }

  _toggleHighlight(tag) {
    this.props.toggleHighlight(tag);
  }

  _isHighlightTag(tag) {
    if (!_.isEmpty(this.state.selectedHighlights)) {
      let index = this.state.selectedHighlights.indexOf(tag);
      if (index > -1) {
        return true;
      }
    }

    return false;
  }

  render() {
    return (
      <div className={styles.headerDiv}>
        <Row>
          <Col md={12}>
            {this.state.highlights &&
              this.state.highlights.map((tag, index) => {
                return (
                  <div
                    className={cx(
                      styles.highlightTag,
                      this._isHighlightTag(tag) ? styles.highlightTagActive : ""
                    )}
                    key={index}
                    onClick={() => this._toggleHighlight(tag)}
                  >
                    <span className={styles.highlightTagText}>{tag}</span>
                  </div>
                );
              })}
          </Col>
        </Row>
      </div>
    );
  }
}

class RecommendedAssets extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      assets: this.props.assets,
      selectedHighlights: this.props.selectedHighlights,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      assets: nextProps.assets,
      selectedHighlights: nextProps.selectedHighlights,
    });
  }

  _renderRecommendedAssets() {
    var assetsCopy = [];
    if (this.state.assets && this.state.assets.length > 0) {
      assetsCopy = this.state.assets.slice(0);
    }

    var filtered = assetsCopy.filter((asset, index) => {
      if (_.isEmpty(this.state.selectedHighlights)) {
        return true;
      }

      if (_.isEmpty(asset.highlights)) {
        return false;
      }

      let highlightExists = false;
      for (const highlight of asset.highlights) {
        let highlightIndex = this.state.selectedHighlights.indexOf(highlight);

        if (highlightIndex > -1 && !highlightExists) {
          highlightExists = true;
        }
      }

      return highlightExists;
    });

    return filtered
      .slice(0, 3)
      .map((asset, index) => <RecommendedAsset key={asset.id} asset={asset} />);
  }

  render() {
    return (
      <div className={styles.recommendedAssetsDiv}>
        <div className={styles.title}>
          Recommended content for this opportunity
        </div>
        {this._renderRecommendedAssets()}
      </div>
    );
  }
}
class RecommendedAsset extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      asset: this.props.asset,
    };
  }
  _handleAssetClick(assetURL){    
    const asset={
      url:assetURL
    }
    window.parent.postMessage(asset, "*");
  }

  render() {
    return (
      <div >
        {this.state.asset && (
          <div key={this.state.asset.id} className={styles.asset}>
            <a href={`/assets/${this.state.asset.id}`} target="_blank">
            <div className={styles.assetThumbnail}>
              <Image
                onClick={()=>{
                    this._handleAssetClick(this.state.asset.id)}}
                className={styles.assetImage}
                src={
                  this.state.asset.icon
                    ? this.state.asset.icon.thumbnail
                    : DefaultAssetIcon
                }
              />
            </div>
            </a>
            <div className={styles.assetDetail}>
            <a href={`/assets/${this.state.asset.id}`} target="_blank">
              <AssetTitle asset={this.state.asset} />
            </a>
              <AssetModified asset={this.state.asset} />
              <AssetMetrics asset={this.state.asset} />
            </div>
            <div className={styles.assetScore}>
              <MatchScore asset={this.state.asset} />
            </div>
          </div>
        )}
      </div>
    );
  }
}

class AssetTitle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      asset: this.props.asset,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      asset: nextProps.asset,
    });
  }

  _handleAssetClick(assetURL){    
    const asset={
      url:assetURL
    }
    window.parent.postMessage(asset, "*");
  }

  render() {
    return (
      <div title={this.state.asset.name}>
        <Link
          onClick={()=>{
            this._handleAssetClick(this.state.asset.id)}}
          className={styles.assetTitle}
        >
          {this.state.asset.name}
        </Link>
      </div>
    );
  }
}

class MatchScore extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      asset: this.props.asset,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ asset: nextProps.asset });
  }

  _formatScore(score) {
    if (score % 1 !== 0) {
      return score.toFixed(2);
    }

    return score;
  }

  getScoreRecommendationText(score) {
    if (score > 65) {
      return "This content is highly recommended for this stage of the deal";
    } else if (score > 30 && score <= 65) {
      return "This content is well recommended for this stage of the deal";
    }

    return "This content is recommended for this stage of the deal";
  }

  render() {
    return (
      <Tooltip content={this.getScoreRecommendationText(this.state.asset.score)} placement="top">
        <div className={styles.assetScoreText}>
          {this.state.asset.score !== 0 && (
            <span>
              {this.state.asset.score > 100
                ? 100
                : this._formatScore(this.state.asset.score)}
              % Match
            </span>
          )}
        </div>
      </Tooltip>
    );
  }
}

class AssetModified extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      asset: this.props.asset,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ asset: nextProps.asset });
  }

  render() {
    return (
      <div className={styles.assetUpdatedBy}>
        Last Updated{" "}
        {dateFormat(new Date(this.state.asset.modifiedDate), "dd mmm yyyy")}
      </div>
    );
  }
}

class AssetMetrics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      asset: this.props.asset,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ asset: nextProps.asset });
  }

  padNumber(number = 0, pad) {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = "";
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join("0");
    }
    return padding + number;
  }

  render() {
    const timeSpent = this.state.asset.avgTimeSpent || 0;
    let timeSpentValue = `~${this.padNumber(Math.round(timeSpent), 1)}s`;

    if (timeSpent >= 60) {
      timeSpentValue = `~${this.padNumber(Math.round(timeSpent / 60), 1)}m`;
    }

    return (
      <div className={styles.metricsRow}>
        <span className={styles.metrics}>
          <i className={cx("paperflite-eye", styles.metricsIcon)} />
          <span className={styles.metricsText}> {this.state.asset.views} </span>
        </span>
        <span className={styles.metrics}>
          <i className={cx("paperflite-share", styles.metricsIcon)} />
          <span className={styles.metricsText}>
            {" "}
            {this.state.asset.shares}{" "}
          </span>
        </span>
        <span className={styles.metrics}>
          <i className={cx("paperflite-history", styles.metricsIcon)} />
          <span className={styles.metricsText}> {timeSpentValue} </span>
        </span>
      </div>
    );
  }
}

export default MsDynamicsOpportunityRecommendedAssetsView;